import type { IconSvgObject } from './types';

const InsertColumnIcon: IconSvgObject = [
  ["path", { d: "M21.5 12L17.5 12M17.5 12H13.5M17.5 12V16M17.5 12L17.5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 21.5L9 2.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 15.5L9 15.5M2.5 8.5L9 8.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21.5 7V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default InsertColumnIcon;
